import {useDispatch, useSelector} from "react-redux";
import ConfirmModal from "./ConfirmModal";
import {setVisibility} from "../redux/slices/dynamicElementsSlice";

const CustomDeleteModal = ({selected, onDelete, modalTitle, children}) => {


  const {
    loading: deleting,
    visible,
    type
  } = useSelector((state) => state.dynamicElements.editing);

  const dispatch = useDispatch();

  const _condition = type === "delete" && visible;


  return (
    <ConfirmModal
      title={modalTitle ?? "Remove"}
      children={children ?? "Are you sure you want to remove this item?"}
      showModal={_condition}
      setShowModal={() => dispatch(setVisibility({visible: false}))}
      disabled={deleting}
      onConfirm={() => onDelete(selected)}
    />
  );
};

export default CustomDeleteModal;

